import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  templateUrl: './app.component.html'
})
export class AppComponent {
  constructor() {
    localStorage.removeItem('firebase:previous_websocket_failure');
  }
 }



// WEBPACK FOOTER //
// ./src/app/app.component.ts